export const YELLOW_STATIONS = [
  {
    "station_id": "BMSD",
    "lat": 12.819404406125182,
    "lng": 77.688334733624,
    "name": "Bommasandra",
    "name_kn": "ಬೊಮ್ಮಸಂದ್ರ",
    "name_hi": "बोम्मसंद्रा",
    "parking": { twoWheeler: 92, fourWheeler: 0 },
  },
  {
    "station_id": "HBGI",
    "lat": 12.828996592208574,
    "lng": 77.68138634958073,
    "name": "Hebbagodi",
    "name_kn": "ಹೆಬ್ಬಗೋಡಿ",
    "name_hi": "हेब्बगोडी",
    "parking": { twoWheeler: 150, fourWheeler: 0 },
  },
  {
    "station_id": "HSKR",
    "lat": 12.83887407402165,
    "lng": 77.67742777885701,
    "name": "Huskur Road",
    "name_kn": "ಹುಸ್ಕೂರು ರಸ್ತೆ",
    "name_hi": "हुस्कुर रोड",
    "parking": { twoWheeler: 0, fourWheeler: 0 },
  },
  {
    "station_id": "ECTN",
    "lat": 12.846272831007383,
    "lng": 77.67116408427252,
    "name": "Infosys Foundation Konappana Agrahara",
    "name_kn": "ಇನ್ಫೋಸಿಸ್ ಫೌಂಡೇಶನ್ ಕೊನಪ್ಪನ ಅಗ್ರಹಾರ",
    "name_hi": "इन्फोसिस फाउंडेशन कोनप्पना अगराहारा",
    "parking": { twoWheeler: 77, fourWheeler: 0 },
  },
  {
    "station_id": "ETCT",
    "lat": 12.85645782533997,
    "lng": 77.66341758234128,
    "name": "Electronic City",
    "name_kn": "ಎಲೆಕ್ಟ್ರಾನಿಕ್ ಸಿಟಿ",
    "name_hi": "इलेक्ट्रॉनिक सिटी",
    "parking": { twoWheeler: 851, fourWheeler: 36 },
  },
  {
    "station_id": "HOSR",
    "lat": 12.86370641198703,
    "lng": 77.65788150201325,
    "name": "Beratena Agrahara",
    "name_kn": "ಬೆರಟೇನ ಅಗ್ರಹಾರ",
    "name_hi": "बेरतेना अगराहारा",
    "parking": { twoWheeler: 0, fourWheeler: 0 },
  },
  {
    "station_id": "BSRD",
    "lat": 12.870682848084016,
    "lng": 77.65233469299186,
    "name": "Hosa Road",
    "name_kn": "ಹೊಸ ರಸ್ತೆ",
    "name_hi": "होसा रोड",
    "parking": { twoWheeler: 90, fourWheeler: 0 },
  },
  {
    "station_id": "CKBR",
    "lat": 12.88065636790883,
    "lng": 77.64481263001042,
    "name": "Singasandra",
    "name_kn": "ಸಿಂಗಸಂದ್ರ",
    "name_hi": "सिंगसंद्रा",
    "parking": { twoWheeler: 90, fourWheeler: 0 },
  },
  {
    "station_id": "MSRN",
    "lat": 12.889811026783377,
    "lng": 77.6391814803426,
    "name": "Kudlu Gate",
    "name_kn": "ಕುಡ್ಲು ಗೇಟ್",
    "name_hi": "कुडलु गेट",
    "parking": { twoWheeler: 85, fourWheeler: 0 },
  },
  {
    "station_id": "OFDC",
    "lat": 12.90159525935582,
    "lng": 77.63195016868947,
    "name": "Hongasandra",
    "name_kn": "ಹೊಂಗಸಂದ್ರ",
    "name_hi": "होंगसंद्रा",
    "parking": { twoWheeler: 155, fourWheeler: 0 },
  },
  {
    "station_id": "HSRL",
    "lat": 12.910649339517972,
    "lng": 77.62641763782084,
    "name": "Bommanahalli",
    "name_kn": "ಬೊಮ್ಮನಹಳ್ಳಿ",
    "name_hi": "बोम्मनहल्ली",
    "parking": { twoWheeler: 85, fourWheeler: 0 },
  },
  {
    "station_id": "SBJT",
    "lat": 12.916427872732415,
    "lng": 77.62045751147937,
    "name": "Central Silk Board",
    "name_kn": "ಸೆಂಟ್ರಲ್ ಸಿಲ್ಕ್ ಬೋರ್ಡ್",
    "name_hi": "सेंट्रल सिल्क बोर्ड",
    "parking": { twoWheeler: 230, fourWheeler: 0 },
  },
  {
    "station_id": "BTML",
    "lat": 12.9165009330627,
    "lng": 77.60806905814847,
    "name": "BTM Layout",
    "name_kn": "ಬಿಟಿಎಂ ಲೇಔಟ್",
    "name_hi": "बीटीएम लेआउट",
    "parking": { twoWheeler: 216, fourWheeler: 0 },
  },
  {
    "station_id": "JDHP",
    "lat": 12.91663714534819,
    "lng": 77.5999206915689,
    "name": "Jayadeva Hospital",
    "name_kn": "ಜಯದೇವ ಆಸ್ಪತ್ರೆ",
    "name_hi": "जयदेव अस्पताल",
    "parking": { twoWheeler: 0, fourWheeler: 0 },
  },
  {
    "station_id": "RGDT",
    "lat": 12.91699427132903,
    "lng": 77.58819679263041,
    "name": "Ragiguda",
    "name_kn": "ರಾಗಿಗುಡ",
    "name_hi": "रागिगुडा",
    "parking": { twoWheeler: 220, fourWheeler: 0 },
  },
  {
    "station_id": "RVR",
    "lat": 12.921587848279543,
    "lng": 77.58025614168618,
    "name": "Rashtreeya Vidyalaya Road",
    "name_kn": "ರಾಷ್ಟ್ರೀಯ ವಿದ್ಯಾಲಯ ರಸ್ತೆ",
    "name_hi": "राष्ट्रीय विद्यालय रोड",
    "parking": { twoWheeler: 223, fourWheeler: 0 },
  },
];
